import React, {createRef, useCallback, useEffect, useRef, useState} from 'react';
import styled from 'styled-components'
import Stripe from "../payment/stripe";
import {trackGaussEvent} from "../helper/analytics";


export default function BuyCourseForm({slug, name, isActive, hasCard = false}) {

    const [showStripeForm, setShowStripeForm] = useState(false)
    const [isSuccessStripe, setIsSuccesStripe] = useState(false)
    const [height, setHeight] = useState('0px')


    useEffect(() => {
        if(isActive) {
            setTimeout(() => setHeight('100vh'), 100)
            trackGaussEvent('buy_course_start_process', {
                leason:  slug ? slug : 'none'
            })
        } else {
            setHeight(0)
            setShowStripeForm(false)
            setIsSuccesStripe(false)
        }


    }, [isActive])

    const showStripeFormAction = () => {
        setShowStripeForm(true)
        trackGaussEvent('buy_course_start_adding_card', {
            leason:  slug ? slug : 'none'
        })
    }

    const redirectToBuyPage = () => {
        setIsSuccesStripe(true)
        trackGaussEvent('buy_course_execute')
        location.href = `/buy/course/${slug}/pay`
    }

    const endStripeForm = () => {
        setIsSuccesStripe(true)
        redirectToBuyPage()

        trackGaussEvent('buy_course_end_adding_card', {
            leason: slug ? slug : 'none'
        })
    }

    const trackBuyPaypal = () => {
        trackGaussEvent('buy_course_paypal', {
            leason: slug ? slug : 'none'
        })

    }

    if(!isActive) return null;

    return (
        <Container hh={height}>
            <Alert>
                <Title>Suscríbete para tener acceso a todo el contenido</Title>

                {(!showStripeForm && !isSuccessStripe) && (
                    <React.Fragment>
                        <BuyButtonsContainer>
                            {!hasCard && (<BuyButtonCard onClick={showStripeFormAction}>Pagar con tarjeta</BuyButtonCard>)}
                            {hasCard && (<BuyButtonCard onClick={redirectToBuyPage}>Pagar con tarjeta</BuyButtonCard>)}

                            <BuyButtonPaypal onClick={trackBuyPaypal} href={`/buy/paypal/course/${slug}`}>Pagar con paypal</BuyButtonPaypal>
                        </BuyButtonsContainer>
                    </React.Fragment>

                )}

                {(!hasCard && showStripeForm && !isSuccessStripe) && (
                    <React.Fragment>
                        <TitleStripe>Necesitamos los datos de tu tarjeta para proseguir con el pago</TitleStripe>
                        <Stripe onFinish={endStripeForm}/>
                    </React.Fragment>
                )}

                {isSuccessStripe && (<StripeSuccess>Procesando el pago</StripeSuccess>)}
            </Alert>
        </Container>
    )
}

const LinkSuscribe = styled.a`
    color: #FA9F63;
    font-size: 14px;
`

const SuscribeContainer = styled.div`
    text-align: center;
    padding-top: 36px;
`

const StripeSuccess = styled.div`
    text-align: center;
`

const BuyButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 36px;
    padding-bottom: 24px;
`

const BuyButtonCard = styled.div`
    padding: 12px;
    border: 1px solid white;
    font-size: 18px;
    color: white;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    margin-right: 16px;

    &:hover {
        background-color: #FA9F63;
        border-color: #FA9F63;

    }
`

const BuyButtonPaypal = styled.a`
    padding: 12px;
    border: 1px solid #003087;
    font-size: 18px;
    color: white;
    text-align: center;
    background-color: #003087;
    cursor: pointer;
    border-radius: 4px;

  &:hover {
        background-color: #0070ba;
        border-color: #0070ba;

    }



`

const Title = styled.div`
    text-align: center;
    color: #FA9F63;
    font-size: 22px;
    font-weight: bold;
    padding-bottom: 24px;

`

const TablePrice = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const TableLabel = styled.div`
    color: #5F676D;
    font-size: 14px;
`

const TablePriceColumns = styled.div`
    color: #5F676D;
    font-size: 16px;
`
const TitleStripe = styled.div`
    color: white;
    font-size: 18px;
    padding-bottom: 12px;
    padding-top: 48px;
`

const Container = styled.div`
    max-height: ${props => props.hh};
    transition: max-height 1s ease;

    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 36px;
    width: 100%;

`

const Alert = styled.div`
    background-color: #0B0E10;
    color: white;
     max-width: 640px;
     padding: 24px;
     flex: 1;
`
